import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import type { ICleaningAreaService } from '../../../services/cleaning-area';
import { CleaningAreaService } from '../../../services/cleaning-area';
import { cleaningAreaQueryKeys } from '../query-keys';

export function useCleaningAreas() {
  const service = useInjection<ICleaningAreaService>(CleaningAreaService);

  const {
    data = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: cleaningAreaQueryKeys.list(),
    queryFn: () => service.findAll(),
  });

  return { areas: data, isLoading, error };
}
